// Tranzila iframe Configuration
// Based on official documentation: https://docs.tranzila.com/docs/payments-billing/795m2yi7q4nmq-iframe-integration
import { BASE_URL } from './site';
export const TRANZILA_CONFIG = {
  // Your Tranzila supplier ID - replace with your actual supplier ID
  supplier: process.env.REACT_APP_TRANZILA_SUPPLIER,

  // Iframe base URL - replace terminalname with your actual terminal name
  iframeBaseURL:
    "https://direct.tranzila.com/" +
    process.env.REACT_APP_TRANZILA_SUPPLIER +
    "/iframenew.php",

  // Handshake configuration
  handshakePassword: process.env.REACT_APP_TRANZILA_HANDSHAKE_PASSWORD,
  handshakeUrl: "https://api.tranzila.com/v1/handshake/create",

  // Default language (Hebrew) - il for Hebrew according to documentation
  defaultLang: "il",

  // Default currency
  defaultCurrency: "ILS",

  // Environment detection
  isProduction: process.env.NODE_ENV === "production",
  isDevelopment: process.env.NODE_ENV === "development",

  // Iframe dimensions
  iframeDimensions: {
    width: "100%",
    height: "600px",
    minHeight: "500px",
  },

  // Iframe styling
  iframeStyles: {
    border: "none",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },

  // Additional iframe parameters
  additionalParams: {
    // Enable/disable features
    enable_credit: false,
    enable_installments: false,
    enable_paypal: false,

    // UI customization
    theme: "light", // light, dark
    responsive: true,

    // Security
    sandbox: true,
  },

  // Hidden fields configuration for cleaner UI
  hiddenFields: {
    hide_credit: true,
    hide_myacount: true,
    hide_contactinfo: true,
    hide_cc: false, // Show credit card form
    hide_billing: true,
    hide_shipping: true,
    hide_notes: true,
    hide_currency: false, // Show currency
    hide_lang: false, // Show language
    hide_sum: false, // Show sum
    hide_description: false, // Show description
    hide_order_id: false, // Show order ID
    hide_customer_name: false, // Show customer name
    hide_customer_email: false, // Show customer email
    hide_customer_phone: false, // Show customer phone
    hide_return_url: true, // Hide return URL
    hide_cancel_url: true, // Hide cancel URL
  },
};

// Get base URL for payment returns
const getBaseUrl = () => {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  // Fallback for server-side rendering
  return process.env.REACT_APP_BASE_URL || "http://localhost:3000";
};

// Firebase Functions host. Tranzila sends a server-to-server notification
// (notify_url_address) to this endpoint after payment, independent of the
// customer's browser. This is the reliable source of truth for marking a
// payment as paid (Safari can block the in-iframe success redirect).
export const FUNCTIONS_BASE_URL: string =
  process.env.REACT_APP_FIREBASE_FUNCTIONS_URL ||
  "https://us-central1-shmuelweb-475f1.cloudfunctions.net";

const PAYMENT_NOTIFY_ENDPOINT = `${FUNCTIONS_BASE_URL}/paymentCallback`;

export const PAYMENT_URLS = {
  success: (registrationId: string) =>
    `${BASE_URL}/payment/success?registrationId=${registrationId}`,
  cancelled: (registrationId: string) =>
    `${BASE_URL}/payment/failed?registrationId=${registrationId}`,
  failed: (registrationId: string) =>
    `${BASE_URL}/payment/failed?registrationId=${registrationId}`,
  notify: (registrationId: string) =>
    `${PAYMENT_NOTIFY_ENDPOINT}?registrationId=${registrationId}`,
};

// Return URLs for gift voucher purchases (reuse the existing payment routes,
// distinguished by the voucherId query param)
export const VOUCHER_PAYMENT_URLS = {
  success: (voucherId: string) =>
    `${BASE_URL}/payment/success?voucherId=${voucherId}`,
  cancelled: (voucherId: string) =>
    `${BASE_URL}/payment/failed?voucherId=${voucherId}`,
  failed: (voucherId: string) =>
    `${BASE_URL}/payment/failed?voucherId=${voucherId}`,
  notify: (voucherId: string) =>
    `${PAYMENT_NOTIFY_ENDPOINT}?voucherId=${voucherId}`,
};

// Test configuration for development
export const TRANZILA_TEST_CONFIG = {
  // Test supplier ID (replace with your test supplier ID)
  testSupplier:
    process.env.REACT_APP_TRANZILA_TEST_SUPPLIER || "test_supplier_id",

  // Test iframe URL
  testIframeURL: "https://direct.tranzila.com/jira/iframenew.php",

  // Test amount
  testAmount: 10,

  // Test description
  testDescription: "Test Payment",
};
